import { __assign } from 'tslib';
import * as React from 'react';

var CloseIcon = function (props) {
    return (React.createElement("svg", __assign({ height: 20, viewBox: "0 0 18 18", width: 20, xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })));
};

export { CloseIcon as default };
//# sourceMappingURL=CloseIcon.esm.js.map
